import { ISapList } from '../models/responseModels'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class SyncCityApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/sap/sync-city',
      requesterInfo,
    })
  }

  public async syncCity(req: any): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
